import React from 'react';
import {OrderApi, OrderTrackingStatus, OrderType} from "../../../../services/Api/types";
import {ReactComponent as CheckCircleIco} from "../../../../../images/icons/check-circle.svg"
import {ReactComponent as DotCircleIco} from "../../../../../images/icons/dot-circle.svg"
import {useTranslation} from "react-i18next";

interface Props {
    status: OrderTrackingStatus;
    orderStatus: OrderTrackingStatus;
    order: OrderApi;
}

const OrderPreparationStatus = ({status, orderStatus, order}: Props) => {
    const {t} = useTranslation();
    const current = orderStatus === status;

    const drawIcon = () => {
        if (current) {
            const checked = orderStatus !== OrderTrackingStatus.PREPARATION;

            if (checked) return <CheckCircleIco/>;

            return <DotCircleIco className="icon"/>;
        }

        return <DotCircleIco className="icon"/>;
    }

    const getStatusTitle = () => {
        switch (status) {
            case OrderTrackingStatus.READY:
                if (order.type === OrderType.DELIVERY) {
                    return t("enums.order.type.DELIVERY");
                }

                if (order.type === OrderType.DINE_IN) {
                    if (order.number) {
                        return t("modules.summary.field.ready.title");
                    }

                    return t("modules.summary.field.ready_to_receive.title");
                }

                return t("modules.summary.field.ready_to_receive.title");
            case OrderTrackingStatus.NEW:
                return t("enums.order.status.ACCEPTED");
            case OrderTrackingStatus.PREPARATION:
                return t("modules.summary.field.preparation.title");
            case OrderTrackingStatus.RECEIVED: {
                if (order.type === OrderType.DELIVERY) {
                    return t("modules.summary.field.delivered.title");
                }

                if (order.type === OrderType.DINE_IN) {
                    if (order.number) {
                        return t("modules.summary.field.delivered_to_table.title");
                    }

                    return t("modules.summary.field.received.title");
                }

                return t("modules.summary.field.received.title");
            }
            default:
                return "";
        }
    }

    return (
        <div className={`summary-order-preparation-status ${current ? "active" : ""}`}>
            <div className="icon-container">
                <span className="pulse"/>
                {drawIcon()}
            </div>
            <p className="mb-0 fw-normal">{getStatusTitle()}</p>
        </div>
    )
}

export default OrderPreparationStatus;